<form role="form" (ngSubmit)="updateInterfaceSettings()" [formGroup]="form">

  <div class="form-group">
    <label i18n for="theme">Theme</label>

    <div class="peertube-select-container">
      <select formControlName="theme" id="theme" class="form-control">
        <option i18n value="instance-default">{{ instanceName }} default theme ({{ getDefaultInstanceThemeLabel() }})</option>
        <option i18n value="default">{{ getDefaultThemeLabel() }}</option>

        <option *ngFor="let theme of availableThemes" [value]="theme.id">{{ theme.label }}</option>
      </select>
    </div>
  </div>

  <input *ngIf="!reactiveUpdate" type="submit" class="mt-0" i18n-value value="Save" [disabled]="!form.valid">
</form>
